import React, {useEffect, useState, useCallback} from 'react';
import ethereum from 'decentralized/ethereum.js';
import {connect} from 'react-redux';

const RecordedMix = ({sequencerEngine, exists, originalMix}) => {
    const [saved, setSaved] = useState(undefined);
    const [name, setName] = useState('');
    const [author, setAuthor] = useState('');

    const clear = useCallback(() => {
        sequencerEngine.clearMix();
        setSaved(undefined);
    }, [setSaved]);

    useEffect(() => {
        if (originalMix) {
            ethereum.users.getUserName(originalMix.user)
                .then(name => setAuthor(name));
        }
    }, [originalMix]);

    const save = useCallback(async () => {
        let json = await sequencerEngine.saveMix(
            originalMix ? originalMix.title : name,
            originalMix && originalMix.mixHash);
        setSaved(json);
    }, [name, setSaved, originalMix]);

    if (!exists) {
        return [];
    }

    if (originalMix) {
        return (
            <div className="recorded-mix">
              <div className="edit-text">
                Edit of <span className="mix-title">{originalMix.title}</span> by <span className="mix-author">{author}</span>
              </div>
              <div className="buttons-container">
                {saved ?
                 '' :
                 <div
                   onClick={save}
                   className="save-mix-button">
                   Save
                 </div>}
                <div
                  onClick={clear}
                  className="clear-mix-button">Clear</div>
              </div>
            </div>

        );
    }

    return (
        <div className="recorded-mix">
          <div className="mix-title">
            {saved === undefined ?
             <input
               placeholder="Enter mix name"
               className="mix-input"
               type="text"
               value={name}
               onChange={(e) => setName(e.target.value)}/> :
             <div>{saved.title}</div>}
          </div>
          <div className="buttons-container">
            {saved ?
             '' :
             <div
               onClick={save}
               className="save-mix-button">
               Save
             </div>}
            <div
              onClick={clear}
              className="clear-mix-button">Clear</div>
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        exists: props.sequencerEngine.events.length > 0
    };
};

export default connect(mapStateToProps, null)(RecordedMix);
